export default __webpack_public_path__ + "static/media/pic3.b54b01fb.jpg";